// extracted by mini-css-extract-plugin
export default {"root":"style_root__dYsLq","title":"style_title__jfNtx"};